import { Component, inject, Input, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MyProvider } from '@assets/services/provider';

import {
  ColorModeService,
  ContainerComponent,
  HeaderComponent,
  HeaderNavComponent,
  HeaderTogglerDirective,
  NavLinkDirective,
  SidebarToggleDirective,
  DropdownComponent,
  DropdownToggleDirective,
  DropdownMenuDirective,
  DropdownItemDirective,
} from '@coreui/angular';

import { IconDirective } from '@coreui/icons-angular';
import { NgCustomSelectComponent } from '@assets/pg/ngselect/ngselect.component';
import { ResetPasswordModalComponent } from 'app/views/Admin/UserInfo/reset-password-modal/reset-password-modal';
import { apiResponse } from 'app/Models/apiResponse';
import { firstValueFrom } from 'rxjs';
import { http } from '@assets/services/services';
import { UserInfoModalComponent } from 'app/views/Admin/UserInfo/user-info-modal/user-info-modal';

@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
  imports: [
    CommonModule,
    ContainerComponent,
    HeaderTogglerDirective,
    SidebarToggleDirective,
    IconDirective,
    HeaderNavComponent,
    NavLinkDirective,
    DropdownComponent,
    DropdownToggleDirective,
    DropdownMenuDirective,
    DropdownItemDirective,
    ResetPasswordModalComponent,
    UserInfoModalComponent,
  ],
  providers: [NgCustomSelectComponent],
})
export class DefaultHeaderComponent extends HeaderComponent {
  private router = inject(Router);
  // public provider = inject(MyProvider);

  @Input() sidebarId: string = 'sidebar1';
  // Remove @ViewChild - we'll use direct property binding instead

  readonly #colorModeService = inject(ColorModeService);
  readonly colorMode = this.#colorModeService.colorMode;

  entity: any = {};
  showResetPasswordModal: boolean = false;
  showUserModal = false;
  resetModalError: string = '';
  selectedUser: any;

  constructor(private http: http, public provider: MyProvider) {
    super();
  }

  logout() {
    this.router.navigate(['login']);
  }

  onUserInfo() {
    this.showUserModal = true;
  }

  onResetPassword() {
    console.log('Reset Password clicked');
    this.showResetPasswordModal = true;
  }

  async onPasswordResetSubmit(data: { userId: string; newPassword: string }) {
    const res: apiResponse = await firstValueFrom(
      this.http.put('UserInfo/resetPsw', null, {
        userId: this.provider.companyinfo.userinfo.user_id,
        newPass: data.newPassword,
      })
    );

    if (res.status_cd == 1) {
      this.showResetPasswordModal = false;
      this.onPasswordResetSuccess();
      this.logout();
    } else {
      this.onPasswordResetError(res.errors.message);
    }
  }

  onPasswordResetSuccess() {
    this.showResetPasswordModal = false;
    this.resetModalError = '';
  }

  onPasswordResetError(error: string) {
    this.resetModalError = error;
  }

  onModalVisibleChange(visible: boolean) {
    this.showResetPasswordModal = visible;
    if (!visible) {
      this.resetModalError = '';
    }
  }

  onUserModalVisibleChange(visible: boolean) {
    this.showUserModal = visible;
  }
}
